import Vue from 'vue'
import AscSparklineChart from '@/components/molecules/AscSparklineChart'

export default Vue.extend({
  components: { AscSparklineChart },

  computed: {
    getData() {
      const data =
        this.params.data && this.params.data.aircraftTrend.length > 0
          ? this.params.data.aircraftTrend
          : []
      return data
    },
  },

  template: `<asc-sparkline-chart :values="getData"></asc-sparkline-chart>`,
})
